import normalize from "json-api-normalizer";

import { makeGetSearchResultsLoaded } from "../../selectors/searchSelectors";
import { GET } from "../../util/apiHelpers";

import { receiveSearchResults } from "../shared/searchActions";

export const fetchSearchResults = (term) => (dispatch) => GET(`/api/v3/employer/search?query=${term}`).then((res) => {
  const normalized = normalize(res.data);
  dispatch(receiveSearchResults(normalized.search || {}, term));
});

const getSearchResultsLoaded = makeGetSearchResultsLoaded();
export const fetchSearchResultsV2 = (term) => (dispatch, getState) => {
  if (!getSearchResultsLoaded(getState(), term)) {
    return GET(`/api/v3/employer/search?query=${term}`).then((res) => {
      const normalized = normalize(res.data);
      return dispatch(receiveSearchResults(normalized.search || {}, term));
    });
  }
  return Promise.resolve();
};
